(() => {
  if (window.__mmPalmaresReady) return;
  window.__mmPalmaresReady = true;

  function initialize(section) {
    if (section.dataset.mmPalmaresInitialized === 'true') return;
    section.dataset.mmPalmaresInitialized = 'true';

    const slides = [...section.querySelectorAll('[data-mm-palmares-slide]')];
    const status = section.querySelector('[data-mm-palmares-status]');
    if (slides.length < 2) return;
    slides.forEach((slide, index) => { slide.hidden = index !== 0; });
    section.classList.add('mm-palmares--ready');
    let current = 0;
    let touchStartX = null;
    let requestId = 0;

    async function show(index, focusSelector = null) {
      const next = (index + slides.length) % slides.length;
      if (next === current) return;
      const thisRequest = ++requestId;
      const photo = slides[next].querySelector('.mm-palmares__photo');
      if (photo && !photo.complete) {
        photo.loading = 'eager';
        try { await photo.decode(); } catch { /* The frame still shows its background if media fails. */ }
      }
      if (thisRequest !== requestId) return;
      slides[current].hidden = true;
      slides[next].hidden = false;
      current = next;
      status.textContent = `Diapositive ${current + 1} sur ${slides.length} : ${slides[current].querySelector('.mm-palmares__title').textContent}`;
      if (focusSelector) slides[current].querySelector(focusSelector)?.focus();
    }

    section.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !section.contains(button)) return;
      if (button.hasAttribute('data-mm-palmares-prev')) show(current - 1, '[data-mm-palmares-prev]');
      else if (button.hasAttribute('data-mm-palmares-next')) show(current + 1, '[data-mm-palmares-next]');
      else if (button.hasAttribute('data-mm-palmares-dot')) {
        const index = Number(button.dataset.mmPalmaresDot);
        show(index, `[data-mm-palmares-dot="${index}"]`);
      }
    });

    section.addEventListener('keydown', (event) => {
      if (!event.target.closest('.mm-palmares__controls')) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1, '[data-mm-palmares-prev]'); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1, '[data-mm-palmares-next]'); }
    });

    section.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.screenX ?? null;
    }, { passive: true });
    section.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = event.changedTouches[0]?.screenX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) > 55) show(current + (distance < 0 ? 1 : -1));
    }, { passive: true });

    section.addEventListener('shopify:block:select', (event) => {
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index !== -1) show(index);
    });
  }

  function initializeAll(root = document) {
    if (root.matches?.('[data-mm-palmares]')) initialize(root);
    root.querySelectorAll('[data-mm-palmares]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
